import React from "react";
import styled from "styled-components";
import { MainLayout } from "layouts";
import { MenuSections } from "components/all";

const menuSections = [
  { label: "서비스 이용약관 (보기)", to: "/all/terms/detail", name: "service" },
  {
    label: "개인정보 처리방침 (보기)",
    to: "/all/terms/detail",
    name: "privacy",
  },
  {
    label: "개인정보 수집 및 이용동의 (보기)",
    to: "/all/terms/detail",
    name: "privacyAgree",
  },
  {
    label: "마케팅 활용 및 광고성 정보 수신 동의서 (보기)",
    to: "/all/terms/detail",
    name: "marketing",
  },
];

const MainCenterSettings = () => {
  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{
        withBackButton: true,
        centerTitle: "약관 및 이용 동의",
      }}
    >
      <Wrapper>
        <MenuSections sections={menuSections} page="terms" />
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0 20px;
`;

export default MainCenterSettings;
